import React from 'react';
import { Minus, Plus } from 'lucide-react';

interface MapControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onPan: (direction: 'up' | 'down' | 'left' | 'right') => void;
}

const MapControls: React.FC<MapControlsProps> = ({ onZoomIn, onZoomOut }) => {
  const btnClass = "w-9 h-9 flex items-center justify-center text-slate-600 hover:text-slate-900 hover:bg-slate-100 active:bg-slate-200 transition-all rounded-lg";

  return (
    <div className="absolute right-4 bottom-8 flex flex-col gap-1 z-10">
      <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-glass-lg p-1 flex flex-col gap-0.5">
        <button onClick={onZoomIn} className={btnClass} aria-label="Zoom in" title="Zoom in (+)">
          <Plus className="w-4 h-4" strokeWidth={2.5} />
        </button>
        <div className="h-px bg-slate-200 mx-1.5" />
        <button onClick={onZoomOut} className={btnClass} aria-label="Zoom out" title="Zoom out (-)">
          <Minus className="w-4 h-4" strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};

export default MapControls;
